import {fetchGet} from "@/libs/reqCommon";
export default {
	state: {
		linkSummary:{},
		linkSummaryDetail: {
			content:[]
		}
	},

	mutations: {
		setLinkSummary(state,payload) {
			state.linkSummary = payload;
		},
		setLinkSummaryDetail(state, payload) {
			state.linkSummaryDetail = payload;
		}
	},

	actions: {
		// 链接汇总列表
		reqLinkSummary({ commit }, params ){
			return new Promise((r, j) => {
				fetchGet("hcm/hcmNewMonitorProduct/getDetailPage",params).then((res) => {
					if(res.status === '10000') {
						commit('setLinkSummary', res.data);
						r(res.data);
					}
				}).catch(() => {
					j();
				})
			})
		},
		// 链接汇总详情
		reqLinkSummaryDetail( { commit }, params ) {
			return new Promise((r, j) => {
				fetchGet("/hcm/wechat/getSkuDetailPage",params).then((res) => {
					if(res.status === '10000') {
						commit('setLinkSummaryDetail', res.data);
						r(res.data);
					}
				}).catch(() => {
					j();
				})
			})
		},
			// 产品监控计划商品详情列表
	reqItemByIdAndTimeList({ commit },params) {
		return new Promise((r,j) => {
			fetchGet("/hcm/wechat/getItemByIdAndTime",params).then((res) => {
				if(res.status === '10000') {
					commit('setLinkSummary', res.data);
					r(res.data);
				}
			}).catch(() => {
				j();
			})
		})
	}

	},
	
}